import './index.scss';
import React, { useState, useEffect } from 'react';
import PdfViewer from '@/components/pdfViewer';
import Player from 'aliplayer-react';
import { ActivityIndicator, Toast } from 'antd-mobile';
import { getPlayUrl as getStreamPlayUrl, getConnections } from '@/services/saas/conference';
import { getPlayUrl as getFilePlayUrl, getViewUrl, getDownloadUrl } from '@/services/saas/res';

const PlayProtocol = 'hls';

const PlayerView = (props) => {
  const { fileInfoId, type, mode, error, config, mbsType } = props;

  const [errorInfo, setErrorInfo] = useState('');

  const [media, setMedia] = useState({
    source: '',
    type: 'video',
  });

  const [loading, setLoading] = useState(false);

  const [param] = useState({
    width: '100%',
    height: '100%',
    autoplay: false,
    isLive: false,
    rePlay: false,
    playsinline: true,
    preload: true,
    controlBarVisibility: 'hover',
    useH5Prism: true,
    liveRetry: 20,
  });

  const getPlaylive = async () => {
    if (fileInfoId) {
      const respConnect = await getConnections({ fileInfoId });
      if (!respConnect.success) {
        return;
      }
      const validStream = respConnect.data.map((item) => item.streamFlag);
      if (validStream.length > 0) {
        const playProtocol = PlayProtocol;
        const repPlayUrl = await getStreamPlayUrl({
          fileInfoId,
          playProtocol,
        });
        if (repPlayUrl && repPlayUrl.success && repPlayUrl.data[playProtocol]) {
          const playUrl = {};
          repPlayUrl.data[playProtocol].forEach((item) => {
            if (validStream.indexOf(item.streamFlag) > -1) {
              playUrl[item.streamFlag] = item.url;
            }
          });
          let source = JSON.stringify(playUrl);
          setMedia({
            source,
            type: 'video',
          });
        }
      } else {
        setErrorInfo('直播信号中断');
      }
    }
  };

  const getMediaPlay = () => {
    console.log(type, mbsType);
    if (type === '1' || type === '5') {
      getFileVideo();
    }
    if (type === '3') {
      getPicUrl();
    }
    if (['2', '4', '6'].includes(type)) {
      if (type === '2' && mbsType === 'mbs') {
        getDocumentUrl();
      } else {
        downloadFile();
      }
    }
  };

  const getFileVideo = async () => {
    if (!fileInfoId) {
      return;
    }
    const playProtocol = PlayProtocol;
    const repPlayUrl = await getFilePlayUrl({
      fileInfoId,
      playProtocol,
    });
    if (repPlayUrl && repPlayUrl.success && repPlayUrl.data[playProtocol]) {
      const playUrl = {};
      repPlayUrl.data[playProtocol].forEach((item) => {
        playUrl[item.resolution] = item.url;
      });
      let source = JSON.stringify(playUrl);
      setMedia({
        source,
        type: 'video',
      });
    } else {
      setErrorInfo(repPlayUrl.msg);
    }
  };

  const downloadFile = async () => {
    if (!fileInfoId) {
      return;
    }
    setLoading(true);
    const responsive = await getDownloadUrl({ fileInfoId });
    if (responsive.success) {
      debugger;
      window.open(responsive.data, '_blank');
    } else {
      Toast.fail(responsive.msg || '查询下载信息失败');
    }
    setLoading(false);
  };

  const getPicUrl = async () => {
    setLoading(true);
    if (!fileInfoId) {
      return;
    }
    const resp = await getViewUrl({ fileInfoId });
    if (resp && resp.success) {
      setMedia({
        source: resp.data,
        type: 'pic',
      });
    } else {
      setErrorInfo(resp.msg);
    }
    setLoading(false);
  };

  const getDocumentUrl = async () => {
    setLoading(true);
    if (!fileInfoId) {
      return;
    }
    const resp = await getViewUrl({ fileInfoId });
    if (resp && resp.success) {
      setMedia({
        source: decodeURI(resp.data),
        type: 'document',
      });
    } else {
      setErrorInfo(resp.msg);
    }
    setLoading(false);
  };

  const getDefault = () => {
    if (mode === 'live') {
      getPlaylive();
    } else {
      getMediaPlay();
    }
  };

  useEffect(() => {
    getDefault();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileInfoId, type, mode]);

  return (
    <div className="player-view">
      {error || errorInfo ? (
        <div className="errorText">{error || errorInfo}</div>
      ) : (
        <>
          {media.type === 'video' && media.source && (
            <Player
              key={fileInfoId}
              config={{
                ...param,
                ...config,
                source: media.source,
                isLive: mode === 'live',
                extraInfo: mode === 'live' ? { crossOrigin: 'anonymous' } : {},
              }}
              onGetInstance={(e) => {
                e.on('error', ({ paramData }) => {
                  setErrorInfo(paramData.display_msg);
                  console.log(paramData.error_msg);
                });
                props.handlePlayer && props.handlePlayer(e);
              }}
            />
          )}
          {media.type === 'pic' && (
            <>
              <ActivityIndicator size="large" animating={loading} />
              <div className="img-container" style={{ display: loading ? 'none' : 'block' }}>
                <img
                  src={media.source}
                  alt="pic"
                  onLoad={() => {
                    setLoading(false);
                  }}
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              </div>
            </>
          )}
          {media.type === 'document' && <PdfViewer file={media.source} />}
        </>
      )}
    </div>
  );
};

export default PlayerView;
